const productTypes = {
  camps: 'camps',
  extras: 'extras',
  accommodations: 'accommodations',
};

export default productTypes;
